import { render, staticRenderFns } from "./store-wares.vue?vue&type=template&id=0572bac3&scoped=true"
import script from "./store-wares.vue?vue&type=script&lang=js"
export * from "./store-wares.vue?vue&type=script&lang=js"
import style0 from "./store-wares.vue?vue&type=style&index=0&id=0572bac3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0572bac3",
  null
  
)

export default component.exports